import React from "react";
import { Box, CircularProgress } from "@mui/material";

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress
        enableTrackSlot
        size="30px"
        aria-label="Loading…"
        sx={{ color: "text.primary" }}
      />
    </Box>
  );
};

export default LoadingScreen;
